import { Component, OnInit } from '@angular/core';
import { first } from 'rxjs/operators';
import { User } from '@app/_models';
import { AuthenticationService, AlertService } from '@app/_services';
import { Router } from '@angular/router';
import { SelectItem, LazyLoadEvent } from 'primeng/api';
import { ReservationService } from '@app/_components/reservation';
import { Table } from 'primeng/table';
import { ConstantService } from '@app/_services/constant.service';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
    selector: 'app-reservation-search-form',
    templateUrl: './reservation-search-form.component.html',
    styleUrls: ['./reservation-search-form.component.css'],
    standalone: false
})
export class ReservationSearchFormComponent implements OnInit {

	datasource: any[];
	reservation: User;
	reservations: any[] = [];
	recordTotal: number;
	lazyLoadEvent: LazyLoadEvent;
	loading = true;



	constructor(
		public authenticationService: AuthenticationService,
		public reservationService: ReservationService,
		public alertService: AlertService,
		public constantService: ConstantService,
		public router: Router,
		private dynamicDialogRef: DynamicDialogRef,
		private dynamicDialogConfig: DynamicDialogConfig,
	) { }


	ngOnInit() {
		if (this.dynamicDialogConfig) {

		}
	}




	loadLazy(event: LazyLoadEvent) {
		try {
			this.loading = true;
			this.lazyLoadEvent = event;
			console.log('EVENT ' + JSON.stringify(event));
			console.log(

				' event.first:' + event.first
				+ '  |  event.rows:' + event.rows
				+ '  |  event.sortField:' + event.sortField
				+ '  |  event.sortOrder:' + event.sortOrder
				+ '  |  event.multiSortMeta:' + JSON.stringify(event.multiSortMeta)
				+ '  |  event.globalFilter:' + event.globalFilter
				+ '  |  event.filters:' + JSON.stringify(event.filters)
			);

			// https://stackoverflow.com/questions/679915/how-do-i-test-for-an-empty-javascript-object
			// if we are filtering by some field (ie property) (event.filters are not empty {})
			if (Object.keys(event.filters).length > 0) {
				console.log('FILTERS!')
				// if there are no other sorts, initialize the event.multiSortMeta
				if (!event.multiSortMeta) {
					event.multiSortMeta = [];
				}
				// sort by checkInDateTime
				event.multiSortMeta.push({ field: 'checkInDateTime', order: -1 });
			}
			else {
				// sort by createDate
				console.log('NO MULTI!')
				if (!event.multiSortMeta) {
					event.multiSortMeta = [];
				}
				event.multiSortMeta.push({ field: 'createDate', order: -1 });
			}




			const pageNumber = Math.round(event.first / event.rows);
			this.reservationService.findByAgentListFilter(
				pageNumber, event.rows,
				event.sortField,
				event.sortOrder,
				event.multiSortMeta,
				event.globalFilter,
				event.filters).pipe(first()).subscribe(

					res => {
						// console.log('reservations are: ' + JSON.stringify(apiResponse));
						this.datasource = res.data.reservations;
						this.recordTotal = res.page.recordTotal;
						this.reservations = res.data.reservations;
					},
					error => {
						console.log('USER LIST!: ' + JSON.stringify(error));
						this.alertService.error(error);
						this.loading = false;
					},
					() => { this.loading = false; }
				);

			if (this.datasource) {
				this.reservations = this.datasource.slice(event.first, (event.first + event.rows));
			}
		} catch (error) {
			console.log('loadLazy(' + event + ')' + error);
		}
	}
	onRowSelect(event) {
		this.dynamicDialogRef.close(event.data);
	}

	getResStatusName(resStatus) {
		return this.constantService.reservationStatuses.find(function(item) { return item.value === resStatus }).label;
	}

	getResStatusColor(resStatus) {
		return this.constantService.reservationStatuses.find(function(item) { return item.value === resStatus }).color;
	}
	clear(table: Table) {
		table.clear();
	}


}
